module.exports = __webpack_public_path__ + "static/media/videotop-min.667a0834.mov";